/*
* 角色管理组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
    Button,
    Space,
} from 'antd';
import {
    PlusOutlined,
} from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    isGTscreenWidth,
    ShowIPModal,
    GetDropdownActionName,
} from '../../incs/FunHelper.js';

import RoleEntity from './RoleEntity';
import RoleSetEntity from './RoleSetEntity';

const Option = Select.Option;
const MODULENAME = CNF.navItems[3].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[3].ptn;

class Lists extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataLists: this.props.dataLists,
            record: null,
            open: false,
        }
    }

    /**
     * 设置打开状态
     * @param {*} value 
     */
    setOpen = (value) => { this.setState({ open: value }); }

    /**
     * 修改
     * @param {*} record 
     */
    update = (record) => { this.props.setIsModalOpen(true, record); }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.dataLists !== nextProps.dataLists) {
            this.setState({
                dataLists: nextProps.dataLists,
            })
        }
    }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    operation = (action, record) => {
        let uri = 'roles/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                this.update(record);
                break;
            case '权限' + CNF.actionName.SET:
                this.authoritySet(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, this.props.isRefresh, uri);
                break
            default:
                break;

        }
    }

    /**
     * 角色权限设置
     * @param {*} record 
     */
    authoritySet(record) {
        this.setState({
            record: record,
            open: true,
        });
    }

    render() {
        const columns = [
            { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
            { title: '角色名', dataIndex: 'rolename', key: 'rolename', },
            { title: '显示名', dataIndex: 'displayname', key: 'displayname', },
            { title: '描述', dataIndex: 'description', key: 'description', },
            { title: '状态', key: 'status', dataIndex: 'status', width: CNF.tableStatusColumnWidth, },
            { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
            { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
            {
                title: '', key: 'operation', width: CNF.tableOperationColumnWidth,
                render: (record) => GetDropdownActionName(this.props.btnLists, MODULENAME_PTN, record, this.operation)
            }
        ];
        return (
            <div>
                <Table
                    columns={columns}
                    size='middle'
                    dataSource={this.state.dataLists}
                    scroll={{ x: this.props.x }}
                    pagination={{
                        showSizeChanger: false,
                        // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                        showQuickJumper: false,
                        showTotal: () => `共${this.props.pageCount}条`,
                        pageSize: CNF.pageSize,
                        current: this.props.currentIndex,
                        total: this.props.pageCount,
                        onShowSizeChange: (current, pageSize) => this.props.changePageSize(pageSize, current),
                        onChange: (current) => this.props.changeIndex(current),
                    }}
                />
                <RoleSetEntity
                    record={this.state.record}
                    open={this.state.open}
                    setOpen={this.setOpen}
                />
            </div>
        );
    }
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            isModalOpen: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            rolename: '',
            displayname: '',
            status: CNF.status[0].value,
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeRolename = (e) => { this.setState({ rolename: e.target.value.replace(/ /g, '') }); if (e.target.value.replace(/ /g, '') !== '') this.search(); }
    changeDisplayname = (e) => { this.setState({ displayname: e.target.value.replace(/ /g, '') }); if (e.target.value.replace(/ /g, '') !== '') this.search(); }
    changeStatus = (value) => { this.setState({ status: value }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    setIsModalOpen = (value, record) => { this.setState({ isModalOpen: value, record: record }); }
    create = () => { this.setIsModalOpen(true, null); }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'rolename': this.state.rolename,
            'displayname': this.state.displayname,
            'status': this.state.status === undefined ? '' : this.state.status,
            'page_size': isGTscreenWidth ? CNF.pageSize : CNF.pageSize - 2,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}roles${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done(function (data) {
            if (data.res === 0) {
                if (data.dat.length > 0) {
                    _this.setState({
                        dataLists: data.dat,
                        pageCount: data.cnt
                    });
                } else {
                    _this.setState({
                        dataLists: [],
                        pageCount: 0
                    });
                }
            } else {
                message.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            message.error(data.responseJSON.detail, CNF.messageDuration);
        });
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <div>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 3 : 4}>
                        <Input
                            onChange={this.changeRolename}
                            placeholder='角色名'
                            value={this.state.rolename}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            onChange={this.changeDisplayname}
                            placeholder='显示名'
                            value={this.state.displayname}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='状态'
                            value={this.state.status}
                            style={{ width: '100%' }}
                            onChange={this.changeStatus}
                        >
                            {
                                CNF.status && CNF.status.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_create') >= 0 ? (
                                <Button
                                    title={CNF.actionName.CREATE + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                        this.create();
                                    }}>
                                    {CNF.actionName.CREATE}
                                </Button>
                            ) : ''
                        }
                    </Space>
                    <RoleEntity
                        policy={this.props.policy}
                        isModalOpen={this.state.isModalOpen}
                        record={this.state.record}
                        setIsModalOpen={this.setIsModalOpen}
                        isRefresh={this.isRefresh}
                    />
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            setIsModalOpen={this.setIsModalOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default CPT